import React, {useRef, useContext} from 'react';
import { useGSAP } from '@gsap/react';
import Context from '../OriginStoryProvider';
import { revealLettersOnScroll } from '../animations/animations';
import gsap from 'gsap';

const TopTextSection = () => {
	const { data: {content} } = useContext(Context);
	
	const chapter1TopTextContainer = useRef(null);

	useGSAP(() => {
		gsap.set('.chapter-1__top-text__highlight-text', {top: '50%', yPercent: -50});
		revealLettersOnScroll('.chapter-1__top-text__highlight', '.chapter-1__top-text__highlight-text', 'top top');
	}, {scope: chapter1TopTextContainer.current, dependencies: [content.chapters]});

	return (
		<div className='main-grid chapter-1__top-text'>
			<div className='main-grid__margin'></div>
			<div className='main-grid__body' ref={chapter1TopTextContainer}>
				<div className='chapter-1__top-text__intro__container'>
					<p className='chapter-1__top-text__drop-cap large-text drop-cap'>{content.chapters.first.top_text_section.intro}</p>
				</div>
				<div className='chapter-1__top-text__highlight'>
					<p className='chapter-1__top-text__highlight-text teaser-sentence'>{content.chapters.first.top_text_section.highlighted_text}</p>
					<svg className="chapter-1__top-text__highlight__bg-shape bg-shape" width="475" height="524" viewBox="0 0 475 524" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M0 0V248.715C0 265.076 2.68918 323.127 37.3107 383.264C76.6558 451.617 141.407 498.261 229.749 521.921L237.5 524L245.251 521.921C333.6 498.261 398.344 451.617 437.689 383.264C472.311 323.127 475 265.076 475 248.715V0H0Z" fill="#CCC6CC"/>
					</svg>
				</div>
			</div>
			<div className='main-grid__margin'></div>
		</div>
	)
}

export default TopTextSection;